module.exports = __webpack_public_path__ + "img/boiler-W-fire.42fc6879.png";